import React from 'react';
import { FaBars, FaSignOutAlt } from 'react-icons/fa';
import './Header.css';

const Header = ({ user, onLogout, toggleSidebar }) => {
  return (
    <header className="header">
      <div className="header-left">
        <button onClick={toggleSidebar} className="sidebar-toggle">
          <FaBars />
        </button>
        <div className="logo-prefeitura">
          <span>LOGO PREFEITURA</span>
          <h1>Prefeitura Municipal</h1>
          <p>Secretaria de Meio Ambiente</p>
        </div>
      </div>
      <div className="header-right">
        <div className="user-info">
          <div className="user-avatar">U</div>
          <span>Usuário {user?.nome || 'Teste'}</span>
        </div>
        <button onClick={onLogout} className="logout-button-header">
          <FaSignOutAlt />
          <span>Sair</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
